import { useContext, useEffect } from "react"
import { useSelector } from "react-redux"
import { bodyContent } from "@/store/apis/matrixApi"
import { buildContentMapEntry } from "@/utils/contentMapEntryBuilder"
import { ContentMapContext } from "@/utils/contentMapContext"
import type { ContentMapEntry } from "@/utils/contentMapTypes"
import {
  returnObjectWithPath,
  type UseContentProps,
} from "@/utils/useContentProps"

export { contentMapBody } from "@/utils/contentMapBody"
export { buildContentMapEntry } from "@/utils/contentMapEntryBuilder"

/** Registers a CMS path with ?contentMap when Matrix bodyContent loads or updates. */
export function useContentMapRegistration(
  props: UseContentProps,
  overrides: Partial<Omit<ContentMapEntry, "refId" | "path">> = {}
) {
  const contentMap = useContext(ContentMapContext)
  const matrixContent = useSelector(bodyContent)
  const normalized = returnObjectWithPath(props)
  const sourceKind = overrides.sourceKind
  const isEnabled = contentMap?.isEnabled ?? false
  const register = contentMap?.register

  useEffect(() => {
    if (!isEnabled || !register) return
    const entry = buildContentMapEntry(matrixContent, props, overrides)
    if (!entry) return
    register(entry)
  }, [isEnabled, register, normalized.path, matrixContent, sourceKind])
}

/** Invisible child that registers a path for useContentJsxArray without violating hook rules. */
export function ContentMapPathRegister({ props }: { props: UseContentProps }) {
  useContentMapRegistration(props)
  return null
}
